import { ISession, IUserProperties } from '@monofe/apiservice';

const updateLanguageId = (session: ISession | null, languageId: number): void => {
    session?.state.setProperty(IUserProperties.LanguageId, languageId);
};

const languageId = (session: ISession | null | undefined): number | null => {
    return session?.state.getProperty<number>(IUserProperties.LanguageId) ?? null;
};

const updateTourId = (session: ISession | null | undefined, tourId: number): void => {
    session?.state.setProperty(IUserProperties.TourId, tourId);
};

const tourId = (session: ISession | null | undefined): number | null => {
    return session?.state.getProperty<number>(IUserProperties.TourId) ?? null;
};

const module = {
    languageId,
    updateLanguageId,
    tourId,
    updateTourId,
};

export default module;
